var exports = {
  "kL": "container__AJJmM_",
  "KE": "toolbar__M7OhmX",
  "Lz": "slimLineTopTabs__pZZq6I",
  "o1": "actions__D7XNqG",
  "Oh": "closeActions__DmXqEp",
  "L": "tabsScrollWrapper__OSBjGu",
  "cW": "rightDivider__FL2lZd",
  "Rr": "scrollContainerTabs__rNYxuE",
  "Qs": "content__RtlsJY",
  "v1": "onlyShowOnLargeViewports__xoGnG_",
  "jJ": "onlyShowInSplitLayout__CdTZsj",
};

module.exports = exports;
